import { ApiEndPoint } from '@/domains/api/api.entity';
import type { HomeApiResponse } from '@/domains/home/home.entity';
import { apiRequest } from './apiRequest';

/**
 * Implementación de la lógica para llamar al API de home (métricas de las institución)
 */
class HomeApiService {
  /**
   * Obtención de las métricas de las institución para mostrar en el home
   */
  async getMetricsForTheHome(): Promise<HomeApiResponse> {
    const metricsForTheHome = await apiRequest.get<HomeApiResponse>({
      route: ApiEndPoint.HOME,
    });

    return metricsForTheHome;
  }
}

export const homeApiService = new HomeApiService();
